import Address from '@/locations/models/address'
import Entity from '@/common/models/entity'

export default class User extends Entity {
  public userName = ''
  public email = ''
  public tenantId: string | null = null
  public role = 'USER'
  public salutation = 'Mrs'
  public title = ''
  public firstName = ''
  public lastName = ''
  public address = new Address()
  public isDeleted = false
  public password = ''
  public abbreviation = ''
}
